var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-toast",on:{"click":_vm.redirectToPage}},[_c('div',{staticClass:"toast-content"},[_c('h6',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }